import { render, staticRenderFns } from "./Locations.vue?vue&type=template&id=a4baa062&scoped=true"
import script from "./Locations.vue?vue&type=script&lang=js"
export * from "./Locations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4baa062",
  null
  
)

export default component.exports